import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  class: "pro_dingdan_all"
};
const _hoisted_3 = {
  style: {
    "width": "100%",
    "text-align": "center",
    "font-size": "20px"
  }
};
const _hoisted_4 = {
  class: "hongse"
};
const _hoisted_5 = {
  style: {
    "height": "800px",
    "overflow-y": "auto"
  }
};
const _hoisted_6 = {
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_7 = {
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_8 = {
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_9 = {
  key: 0,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_10 = {
  class: "acea-row row-top"
};
const _hoisted_11 = {
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_12 = {
  class: "acea-row row-top"
};
const _hoisted_13 = {
  key: 1,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_14 = {
  key: 2,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_15 = {
  class: "acea-row row-top"
};
const _hoisted_16 = {
  key: 3,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_17 = {
  key: 4,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_18 = {
  class: "acea-row row-top"
};
const _hoisted_19 = {
  key: 5,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_20 = {
  key: 6,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_21 = {
  class: "acea-row row-top"
};
const _hoisted_22 = {
  key: 7,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_23 = {
  key: 8,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_24 = {
  class: "acea-row row-top"
};
const _hoisted_25 = {
  key: 9,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_26 = {
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_27 = {
  class: "acea-row row-top"
};
const _hoisted_28 = {
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_29 = {
  class: "acea-row row-top"
};
const _hoisted_30 = {
  key: 10,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_31 = {
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_32 = {
  class: "acea-row row-top"
};
const _hoisted_33 = {
  key: 11,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_34 = {
  class: "acea-row row-top"
};
const _hoisted_35 = {
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_36 = {
  class: "acea-row row-top"
};
const _hoisted_37 = {
  key: 12,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_38 = {
  class: "acea-row row-top"
};
const _hoisted_39 = {
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_40 = {
  class: "acea-row row-top"
};
const _hoisted_41 = {
  key: 0,
  class: "hongse"
};
const _hoisted_42 = {
  key: 13,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_43 = {
  class: "acea-row row-top"
};
const _hoisted_44 = {
  key: 14,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_45 = {
  class: "acea-row row-top"
};
const _hoisted_46 = {
  key: 15,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_47 = {
  key: 16,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_48 = {
  class: "acea-row row-top"
};
const _hoisted_49 = {
  key: 17,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_50 = {
  key: 18,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_51 = {
  class: "acea-row row-top"
};
const _hoisted_52 = {
  key: 19,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_53 = {
  class: "acea-row row-top"
};
const _hoisted_54 = {
  key: 20,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_55 = {
  key: 21,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_56 = {
  key: 22,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_57 = {
  key: 23,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_58 = {
  key: 24,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_59 = {
  class: "acea-row row-top"
};
const _hoisted_60 = {
  key: 25,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_61 = {
  class: "acea-row row-top"
};
const _hoisted_62 = {
  key: 26,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_63 = {
  class: "acea-row row-top"
};
const _hoisted_64 = {
  key: 27,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_65 = {
  key: 28,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_66 = {
  class: "acea-row row-top"
};
const _hoisted_67 = {
  key: 29,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_68 = {
  class: "acea-row row-top"
};
const _hoisted_69 = {
  key: 30,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_70 = {
  class: "acea-row row-top"
};
const _hoisted_71 = {
  key: 31,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_72 = {
  class: "acea-row row-top"
};
const _hoisted_73 = {
  key: 32,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_74 = {
  class: "acea-row row-top"
};
const _hoisted_75 = {
  key: 33,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_76 = {
  key: 34,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_77 = {
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_78 = {
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_79 = {
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_80 = {
  class: "acea-row row-top"
};
const _hoisted_81 = {
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_82 = {
  class: "acea-row row-top"
};
const _hoisted_83 = {
  key: 35,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_84 = ["innerHTML"];
const _hoisted_85 = {
  key: 36,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_86 = {
  key: 37,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_87 = {
  key: 38,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_88 = {
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_89 = {
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_90 = {
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_91 = {
  class: "acea-row row-top"
};
const _hoisted_92 = {
  key: 39,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_93 = ["innerHTML"];
const _hoisted_94 = {
  key: 40,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_95 = {
  key: 41,
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_96 = {
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_97 = {
  class: "acea-row row-top"
};
const _hoisted_98 = {
  style: {
    "padding": "20px 0"
  }
};
const _hoisted_99 = {
  class: "mb10 acea-row row-top row-top"
};
const _hoisted_100 = {
  style: {
    "margin-bottom": "5px"
  }
};
const _hoisted_101 = {
  class: "mb10 acea-row row-top row-top"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_zrcheader = _resolveComponent("zrcheader");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_radio_button = _resolveComponent("el-radio-button");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_Option = _resolveComponent("Option");
  const _component_Select = _resolveComponent("Select");
  const _component_UploadFilled = _resolveComponent("UploadFilled");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_Close = _resolveComponent("Close");
  const _component_zrcfooter = _resolveComponent("zrcfooter");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_zrcheader, {
    xzmenu: $data.xzmenu
  }, null, 8, ["xzmenu"]), _cache[116] || (_cache[116] = _createElementVNode("div", {
    class: "shop_postion"
  }, "当前位置： 主页 > 项目订单", -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[56] || (_cache[56] = _createTextVNode("预估费用:")), _createElementVNode("span", _hoisted_4, "￥" + _toDisplayString($data.yugufeiyong) + "元", 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[57] || (_cache[57] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("样品数量 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 3
  }, {
    default: _withCtx(() => [_createVNode(_component_el_input, {
      type: "number",
      modelValue: $data.dingdaninfo.sampnum,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.dingdaninfo.sampnum = $event),
      min: 1,
      placeholder: "请输入样品数量",
      onChange: $options.self_sampnum_Change
    }, null, 8, ["modelValue", "onChange"])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[58] || (_cache[58] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("样品编号 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createVNode(_component_el_input, {
      type: "textarea",
      modelValue: $data.dingdaninfo.sampbianhao,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.dingdaninfo.sampbianhao = $event),
      placeholder: "请输入样品编号"
    }, null, 8, ["modelValue"])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[59] || (_cache[59] = [_createTextVNode(" 样品性质 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createVNode(_component_el_input, {
      type: "textarea",
      modelValue: $data.dingdaninfo.sampxinxi,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.dingdaninfo.sampxinxi = $event),
      placeholder: "请输入样品信息"
    }, null, 8, ["modelValue"])]),
    _: 1
  })]), $data.projectinfo.leixing_id == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[60] || (_cache[60] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("样品磁性 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_radio_group, {
      modelValue: $data.dingdaninfo.xzcixingid,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.dingdaninfo.xzcixingid = $event),
      onChange: $options.getyugufeiyong
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.cixinglist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_el_radio_button, {
          value: itemn.value,
          key: indexn
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(itemn.name) + "(" + _toDisplayString(itemn.price) + "元)", 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue", "onChange"])])]),
    _: 1
  })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[61] || (_cache[61] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("样品形态 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_radio_group, {
      modelValue: $data.dingdaninfo.xzzhuangtaiid,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.dingdaninfo.xzzhuangtaiid = $event)
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.zhuangtailist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_el_radio_button, {
          value: itemn.value,
          key: indexn
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(itemn.name) + _toDisplayString(itemn.danwei), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"])])]),
    _: 1
  })]), $data.dingdaninfo.xzzhuangtaiid > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[62] || (_cache[62] = [_createTextVNode(" 样品形态具体数量 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createVNode(_component_el_input, {
      type: "text",
      modelValue: $data.dingdaninfo.xzzhuangtaibeizhu,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.dingdaninfo.xzzhuangtaibeizhu = $event),
      placeholder: "样品形态具体数量"
    }, null, 8, ["modelValue"])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.projectinfo.leixing_id == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[63] || (_cache[63] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("前处理 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_radio_group, {
      modelValue: $data.dingdaninfo.xzqianchuliid,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.dingdaninfo.xzqianchuliid = $event),
      onChange: $options.getyugufeiyong
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.qianchulilist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_el_radio_button, {
          value: itemn.value,
          key: indexn
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(itemn.name) + "(" + _toDisplayString(itemn.price) + "元)", 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue", "onChange"])])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.dingdaninfo.xzqianchuliid > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[64] || (_cache[64] = [_createTextVNode(" 前处理备注 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createVNode(_component_el_input, {
      type: "text",
      modelValue: $data.dingdaninfo.xzqianchulibeizhu,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.dingdaninfo.xzqianchulibeizhu = $event),
      placeholder: "前处理备注"
    }, null, 8, ["modelValue"])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.projectinfo.leixing_id == 2 || $data.projectinfo.leixing_id == 11 ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[65] || (_cache[65] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("分散剂 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createVNode(_component_el_radio_group, {
      modelValue: $data.dingdaninfo.xzfensanjiid,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.dingdaninfo.xzfensanjiid = $event),
      onChange: $options.getyugufeiyong
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.fensanjilist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_el_radio_button, {
          value: itemn.value,
          key: indexn
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(itemn.name) + "(" + _toDisplayString(itemn.price) + "元)", 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue", "onChange"])])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.dingdaninfo.xzfensanjiid > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[66] || (_cache[66] = [_createTextVNode(" 分散剂备注 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createVNode(_component_el_input, {
      type: "text",
      modelValue: $data.dingdaninfo.xzfensanjibeizhu,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.dingdaninfo.xzfensanjibeizhu = $event),
      placeholder: "分散剂备注"
    }, null, 8, ["modelValue"])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.projectinfo.leixing_id == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[67] || (_cache[67] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("样品制备 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_21, [_createVNode(_component_el_radio_group, {
      modelValue: $data.dingdaninfo.xzzhibeiid,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.dingdaninfo.xzzhibeiid = $event),
      onChange: $options.getyugufeiyong
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.zhibeilist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_el_radio_button, {
          value: itemn.value,
          key: indexn
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(itemn.name) + "(" + _toDisplayString(itemn.price) + "元)", 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue", "onChange"])])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.dingdaninfo.xzzhibeiid > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[68] || (_cache[68] = [_createTextVNode(" 样品制备备注 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createVNode(_component_el_input, {
      type: "text",
      modelValue: $data.dingdaninfo.xzzhibeibeizhu,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.dingdaninfo.xzzhibeibeizhu = $event),
      placeholder: "样品制备备注"
    }, null, 8, ["modelValue"])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.projectinfo.leixing_id == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[69] || (_cache[69] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("超声时间 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_24, [_createVNode(_component_el_radio_group, {
      modelValue: $data.dingdaninfo.xzchaoshengsjid,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.dingdaninfo.xzchaoshengsjid = $event),
      onChange: $options.getyugufeiyong
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.chaoshengsjlist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_el_radio_button, {
          value: itemn.value,
          key: indexn
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(itemn.name) + "(" + _toDisplayString(itemn.price) + "元)", 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue", "onChange"])])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.dingdaninfo.xzchaoshengsjid > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[70] || (_cache[70] = [_createTextVNode(" 超声时间备注 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createVNode(_component_el_input, {
      type: "text",
      modelValue: $data.dingdaninfo.xzchaoshengsjbeizhu,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.dingdaninfo.xzchaoshengsjbeizhu = $event),
      placeholder: "超声时间备注"
    }, null, 8, ["modelValue"])]),
    _: 1
  })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_26, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[71] || (_cache[71] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("样品危险性 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_27, [_createVNode(_component_el_radio_group, {
      modelValue: $data.dingdaninfo.xzweixianid,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.dingdaninfo.xzweixianid = $event)
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.weixianlist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_el_radio_button, {
          value: itemn.value,
          key: indexn
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(itemn.name), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"])])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_28, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[72] || (_cache[72] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("存放要求 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_29, [_createVNode(_component_el_radio_group, {
      modelValue: $data.dingdaninfo.xzbaocunid,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $data.dingdaninfo.xzbaocunid = $event)
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.baocunlist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_el_radio_button, {
          value: itemn.value,
          key: indexn
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(itemn.name), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"])])]),
    _: 1
  })]), $data.dingdaninfo.xzbaocunid > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[73] || (_cache[73] = [_createTextVNode(" 存放要求备注 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createVNode(_component_el_input, {
      type: "text",
      modelValue: $data.dingdaninfo.xzbaocunbeizhu,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => $data.dingdaninfo.xzbaocunbeizhu = $event),
      placeholder: "存放要求备注"
    }, null, 8, ["modelValue"])]),
    _: 1
  })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_31, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[74] || (_cache[74] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("设备型号 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_32, [_createVNode(_component_el_radio_group, {
      modelValue: $data.dingdaninfo.xzshebeitypeid,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => $data.dingdaninfo.xzshebeitypeid = $event)
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shebeitypelist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_el_radio_button, {
          value: itemn.value,
          key: indexn
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(itemn.name), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"])])]),
    _: 1
  })]), $data.dingdaninfo.xzshebeitypeid == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[75] || (_cache[75] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("仪器设备 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_34, [_createVNode(_component_el_radio_group, {
      modelValue: $data.dingdaninfo.xzyiqishebeiid,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $data.dingdaninfo.xzyiqishebeiid = $event)
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.yiqishebeilist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_el_radio_button, {
          value: itemn.value,
          key: indexn
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(itemn.name), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"])])]),
    _: 1
  })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_35, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[76] || (_cache[76] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("测试方式 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_36, [_createVNode(_component_el_radio_group, {
      modelValue: $data.dingdaninfo.xzceshitypeid,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => $data.dingdaninfo.xzceshitypeid = $event),
      onChange: $options.getceshixiangmu
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.ceshitypelist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_el_radio_button, {
          value: itemn.value,
          key: indexn
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(itemn.name), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue", "onChange"])])]),
    _: 1
  })]), $data.dingdaninfo.xzceshitypeid == 1 || $data.dingdaninfo.xzceshitypeid == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[77] || (_cache[77] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("时长(现场/云现场) ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_38, [_createVNode(_component_el_radio_group, {
      modelValue: $data.dingdaninfo.xzhourid,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => $data.dingdaninfo.xzhourid = $event),
      onChange: $options.getyugufeiyong
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.hourlist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_el_radio_button, {
          value: itemn.value,
          key: indexn
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(itemn.name), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue", "onChange"])])]),
    _: 1
  })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_39, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[78] || (_cache[78] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("测试项目 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_40, [_createVNode(_component_el_checkbox_group, {
      modelValue: $data.dingdaninfo.xzceshixiangmuids,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => $data.dingdaninfo.xzceshixiangmuids = $event),
      onChange: $options.getyugufeiyong,
      class: "acea-row row-top"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.ceshimingxilist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          value: itemn.value,
          key: indexn,
          border: "",
          style: {
            "margin-bottom": "5px"
          }
        }, {
          default: _withCtx(() => [itemn.is_bixu == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_41, "*")) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(itemn.name), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue", "onChange"])])]),
    _: 1
  })]), $data.projectinfo.leixing_id == 10 ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[79] || (_cache[79] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("测试办法 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_43, [_createVNode(_component_el_radio_group, {
      modelValue: $data.dingdaninfo.xzceshifangfaid,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => $data.dingdaninfo.xzceshifangfaid = $event)
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.ceshifangfalist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_el_radio, {
          value: itemn.value,
          key: indexn
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(itemn.name), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"])])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.projectinfo.leixing_id == 10 ? (_openBlock(), _createElementBlock("div", _hoisted_44, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[80] || (_cache[80] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("数据形式 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_45, [_createVNode(_component_el_radio_group, {
      modelValue: $data.dingdaninfo.xzshujuxingshiid,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => $data.dingdaninfo.xzshujuxingshiid = $event)
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shujuxingshilist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_el_radio, {
          value: itemn.value,
          key: indexn
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(itemn.name), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"])])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.projectinfo.leixing_id == 11 ? (_openBlock(), _createElementBlock("div", _hoisted_46, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[81] || (_cache[81] = [_createTextVNode(" 样品颗粒范围 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createVNode(_component_el_input, {
      type: "textarea",
      modelValue: $data.dingdaninfo.yangp_kelifanwei,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => $data.dingdaninfo.yangp_kelifanwei = $event),
      placeholder: "请输入样品颗粒范围"
    }, null, 8, ["modelValue"])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.projectinfo.leixing_id == 11 ? (_openBlock(), _createElementBlock("div", _hoisted_47, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[82] || (_cache[82] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("是否需要超声 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_48, [_createVNode(_component_el_radio_group, {
      modelValue: $data.dingdaninfo.xzischaoshengid,
      "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => $data.dingdaninfo.xzischaoshengid = $event)
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shifoulist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_el_radio, {
          value: itemn.value,
          key: indexn
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(itemn.name), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"])])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.projectinfo.leixing_id == 11 && $data.dingdaninfo.xzischaoshengid == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_49, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[83] || (_cache[83] = [_createTextVNode(" 超声分钟 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createVNode(_component_el_input, {
      type: "textarea",
      modelValue: $data.dingdaninfo.chaoshen_fenzhong,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => $data.dingdaninfo.chaoshen_fenzhong = $event),
      placeholder: "请输入超声分钟"
    }, null, 8, ["modelValue"])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.projectinfo.leixing_id == 11 ? (_openBlock(), _createElementBlock("div", _hoisted_50, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[84] || (_cache[84] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("是否需要调解ph值 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_51, [_createVNode(_component_el_radio_group, {
      modelValue: $data.dingdaninfo.xzistiaojiephzhiid,
      "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => $data.dingdaninfo.xzistiaojiephzhiid = $event)
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shifoulist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_el_radio, {
          value: itemn.value,
          key: indexn
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(itemn.name), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"])])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.projectinfo.leixing_id == 11 ? (_openBlock(), _createElementBlock("div", _hoisted_52, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[85] || (_cache[85] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("测试PH值个数 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_53, [_createVNode(_component_el_radio_group, {
      modelValue: $data.dingdaninfo.xzphzhiid,
      "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => $data.dingdaninfo.xzphzhiid = $event)
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.phzhilist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_el_radio, {
          value: itemn.value,
          key: indexn
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(itemn.name), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"])])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.projectinfo.leixing_id == 11 ? (_openBlock(), _createElementBlock("div", _hoisted_54, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[86] || (_cache[86] = [_createTextVNode(" 具体测试PH值 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createVNode(_component_el_input, {
      type: "textarea",
      modelValue: $data.dingdaninfo.ph_zhi,
      "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => $data.dingdaninfo.ph_zhi = $event),
      placeholder: "请输入具体测试PH值"
    }, null, 8, ["modelValue"])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.projectinfo.leixing_id == 11 ? (_openBlock(), _createElementBlock("div", _hoisted_55, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[87] || (_cache[87] = [_createTextVNode(" 样品折射率 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createVNode(_component_el_input, {
      type: "textarea",
      modelValue: $data.dingdaninfo.yangp_zheshelv,
      "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => $data.dingdaninfo.yangp_zheshelv = $event),
      placeholder: "请输入样品折射率"
    }, null, 8, ["modelValue"])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.projectinfo.leixing_id == 12 ? (_openBlock(), _createElementBlock("div", _hoisted_56, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[88] || (_cache[88] = [_createTextVNode(" 样品特性(溶剂及溶液浓度) ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createVNode(_component_el_input, {
      type: "textarea",
      modelValue: $data.dingdaninfo.texing_rongjiyelongdu,
      "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => $data.dingdaninfo.texing_rongjiyelongdu = $event),
      placeholder: "请输入样品特性(溶剂及溶液浓度)"
    }, null, 8, ["modelValue"])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.projectinfo.leixing_id == 12 ? (_openBlock(), _createElementBlock("div", _hoisted_57, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[89] || (_cache[89] = [_createTextVNode(" 样品特性(测试面) ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createVNode(_component_el_input, {
      type: "textarea",
      modelValue: $data.dingdaninfo.texing_ceshimian,
      "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => $data.dingdaninfo.texing_ceshimian = $event),
      placeholder: "请输入样品特性(测试面)"
    }, null, 8, ["modelValue"])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.projectinfo.leixing_id == 12 ? (_openBlock(), _createElementBlock("div", _hoisted_58, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[90] || (_cache[90] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("测试模式 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_59, [_createVNode(_component_el_radio_group, {
      modelValue: $data.dingdaninfo.xzceshimoshiid,
      "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => $data.dingdaninfo.xzceshimoshiid = $event)
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.ceshimoshilist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_el_radio, {
          value: itemn.value,
          key: indexn
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(itemn.name), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"])])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.projectinfo.leixing_id == 12 ? (_openBlock(), _createElementBlock("div", _hoisted_60, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[91] || (_cache[91] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("测试模式 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_61, [_createVNode(_component_el_radio_group, {
      modelValue: $data.dingdaninfo.xzceshicanshuid,
      "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => $data.dingdaninfo.xzceshicanshuid = $event)
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.ceshicanshulist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_el_radio, {
          value: itemn.value,
          key: indexn
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(itemn.name), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"])])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.projectinfo.leixing_id == 12 ? (_openBlock(), _createElementBlock("div", _hoisted_62, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[92] || (_cache[92] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("波长范围 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_63, [_createVNode(_component_el_radio_group, {
      modelValue: $data.dingdaninfo.xzbochangfanweiid,
      "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => $data.dingdaninfo.xzbochangfanweiid = $event)
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.bochangfanweilist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_el_radio, {
          value: itemn.value,
          key: indexn
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(itemn.name), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"])])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.projectinfo.leixing_id == 12 ? (_openBlock(), _createElementBlock("div", _hoisted_64, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[93] || (_cache[93] = [_createTextVNode(" 实际波长范围 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createVNode(_component_el_input, {
      type: "textarea",
      modelValue: $data.dingdaninfo.shijibochangfanwei,
      "onUpdate:modelValue": _cache[36] || (_cache[36] = $event => $data.dingdaninfo.shijibochangfanwei = $event),
      placeholder: "请输入实际波长范围"
    }, null, 8, ["modelValue"])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.projectinfo.leixing_id == 7 ? (_openBlock(), _createElementBlock("div", _hoisted_65, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[94] || (_cache[94] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("EPR低温 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_66, [_createVNode(_component_el_radio_group, {
      modelValue: $data.dingdaninfo.epr_diwenshifou_id,
      "onUpdate:modelValue": _cache[37] || (_cache[37] = $event => $data.dingdaninfo.epr_diwenshifou_id = $event)
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shifoulist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_el_radio, {
          value: itemn.value,
          key: indexn
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(itemn.name), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"])])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.projectinfo.leixing_id == 7 ? (_openBlock(), _createElementBlock("div", _hoisted_67, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[95] || (_cache[95] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("EPR定量分析 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_68, [_createVNode(_component_el_radio_group, {
      modelValue: $data.dingdaninfo.epr_diliangfxshifou_id,
      "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => $data.dingdaninfo.epr_diliangfxshifou_id = $event)
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shifoulist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_el_radio, {
          value: itemn.value,
          key: indexn
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(itemn.name), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"])])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.projectinfo.leixing_id == 7 ? (_openBlock(), _createElementBlock("div", _hoisted_69, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[96] || (_cache[96] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("EPR光照/变温 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_70, [_createVNode(_component_el_radio_group, {
      modelValue: $data.dingdaninfo.epr_guangzbg_id,
      "onUpdate:modelValue": _cache[39] || (_cache[39] = $event => $data.dingdaninfo.epr_guangzbg_id = $event)
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.guangzhaobwlist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_el_radio, {
          value: itemn.value,
          key: indexn
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(itemn.name), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"])])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.projectinfo.leixing_id == 7 ? (_openBlock(), _createElementBlock("div", _hoisted_71, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[97] || (_cache[97] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("EPR自由基类型 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_72, [_createVNode(_component_el_radio_group, {
      modelValue: $data.dingdaninfo.epr_ziyoujitype_id,
      "onUpdate:modelValue": _cache[40] || (_cache[40] = $event => $data.dingdaninfo.epr_ziyoujitype_id = $event)
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.ziyoujitypelist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_el_radio, {
          value: itemn.value,
          key: indexn
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(itemn.name), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"])])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.projectinfo.leixing_id == 7 ? (_openBlock(), _createElementBlock("div", _hoisted_73, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[98] || (_cache[98] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("EPR自由基时间点数 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_74, [_createVNode(_component_el_radio_group, {
      modelValue: $data.dingdaninfo.epr_ziyoujitimedianshu_id,
      "onUpdate:modelValue": _cache[41] || (_cache[41] = $event => $data.dingdaninfo.epr_ziyoujitimedianshu_id = $event)
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.ziyoujitimedianshulist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_el_radio, {
          value: itemn.value,
          key: indexn
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(itemn.name), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"])])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.projectinfo.leixing_id == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_75, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[99] || (_cache[99] = [_createTextVNode(" 电镜放大倍数 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createVNode(_component_el_input, {
      type: "textarea",
      modelValue: $data.dingdaninfo.dianjingfadabeishu,
      "onUpdate:modelValue": _cache[42] || (_cache[42] = $event => $data.dingdaninfo.dianjingfadabeishu = $event),
      placeholder: "请输入电镜放大倍数"
    }, null, 8, ["modelValue"])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.projectinfo.leixing_id == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_76, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[100] || (_cache[100] = [_createTextVNode(" 能谱要求 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createVNode(_component_el_input, {
      type: "textarea",
      modelValue: $data.dingdaninfo.nengpuyaoqiu,
      "onUpdate:modelValue": _cache[43] || (_cache[43] = $event => $data.dingdaninfo.nengpuyaoqiu = $event),
      placeholder: "请输入能谱要求"
    }, null, 8, ["modelValue"])]),
    _: 1
  })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_77, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[101] || (_cache[101] = [_createTextVNode(" 其他测试要求 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createVNode(_component_el_input, {
      type: "textarea",
      modelValue: $data.dingdaninfo.ceshiyaoqiu,
      "onUpdate:modelValue": _cache[44] || (_cache[44] = $event => $data.dingdaninfo.ceshiyaoqiu = $event),
      placeholder: "请输入其他测试要求"
    }, null, 8, ["modelValue"])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_78, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[102] || (_cache[102] = [_createTextVNode(" 实验备注 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createVNode(_component_el_input, {
      type: "textarea",
      modelValue: $data.dingdaninfo.shiyanbeizhu,
      "onUpdate:modelValue": _cache[45] || (_cache[45] = $event => $data.dingdaninfo.shiyanbeizhu = $event),
      placeholder: "请输入实验备注"
    }, null, 8, ["modelValue"])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_79, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[103] || (_cache[103] = [_createTextVNode(" 预计送样时间 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_80, [_createVNode(_component_el_date_picker, {
      type: "date",
      value: $data.dingdaninfo.yujisongyangtime,
      placeholder: "请选择时间",
      style: {
        "width": "200px"
      }
    }, null, 8, ["value"])])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_81, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[104] || (_cache[104] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("样品回收 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_82, [_createVNode(_component_el_radio_group, {
      modelValue: $data.dingdaninfo.xzhuishoutypeid,
      "onUpdate:modelValue": _cache[46] || (_cache[46] = $event => $data.dingdaninfo.xzhuishoutypeid = $event),
      onChange: $options.getyugufeiyong
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.huishoutypelist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_el_radio, {
          value: itemn.value,
          key: indexn
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(itemn.name), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue", "onChange"])])]),
    _: 1
  })]), $data.dingdaninfo.xzhuishoutypeid > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_83, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      style: {
        "color": "#f8a70a",
        "text-align": "left"
      },
      innerHTML: $data.huishoutype_beizhu
    }, null, 8, _hoisted_84)]),
    _: 1
  })])) : _createCommentVNode("", true), $data.dingdaninfo.xzhuishoutypeid == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_85, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[105] || (_cache[105] = [_createTextVNode(" 回收联系人 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createVNode(_component_el_input, {
      type: "text",
      modelValue: $data.dingdaninfo.huishou_name,
      "onUpdate:modelValue": _cache[47] || (_cache[47] = $event => $data.dingdaninfo.huishou_name = $event),
      placeholder: "回收联系人"
    }, null, 8, ["modelValue"])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.dingdaninfo.xzhuishoutypeid == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_86, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[106] || (_cache[106] = [_createTextVNode(" 回收联系电话 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createVNode(_component_el_input, {
      type: "text",
      modelValue: $data.dingdaninfo.huishou_tel,
      "onUpdate:modelValue": _cache[48] || (_cache[48] = $event => $data.dingdaninfo.huishou_tel = $event),
      placeholder: "回收联系电话"
    }, null, 8, ["modelValue"])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.dingdaninfo.xzhuishoutypeid == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_87, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[107] || (_cache[107] = [_createTextVNode(" 回收联系地址 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createVNode(_component_el_input, {
      type: "text",
      modelValue: $data.dingdaninfo.huishou_dizhi,
      "onUpdate:modelValue": _cache[49] || (_cache[49] = $event => $data.dingdaninfo.huishou_dizhi = $event),
      placeholder: "实验联系地址"
    }, null, 8, ["modelValue"])]),
    _: 1
  })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_88, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[108] || (_cache[108] = [_createTextVNode(" 实验联系人 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createVNode(_component_el_input, {
      type: "text",
      modelValue: $data.dingdaninfo.shiyan_lianxiren_name,
      "onUpdate:modelValue": _cache[50] || (_cache[50] = $event => $data.dingdaninfo.shiyan_lianxiren_name = $event),
      placeholder: "实验联系人"
    }, null, 8, ["modelValue"])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_89, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[109] || (_cache[109] = [_createTextVNode(" 实验联系电话 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createVNode(_component_el_input, {
      type: "text",
      modelValue: $data.dingdaninfo.shiyan_lianxiren_tel,
      "onUpdate:modelValue": _cache[51] || (_cache[51] = $event => $data.dingdaninfo.shiyan_lianxiren_tel = $event),
      placeholder: "实验联系电话"
    }, null, 8, ["modelValue"])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_90, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[110] || (_cache[110] = [_createElementVNode("span", {
      class: "hongse"
    }, "*", -1), _createTextVNode("送样方式 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_91, [_createVNode(_component_el_radio_group, {
      modelValue: $data.dingdaninfo.xzquyangtypeid,
      "onUpdate:modelValue": _cache[52] || (_cache[52] = $event => $data.dingdaninfo.xzquyangtypeid = $event),
      onChange: $options.self_quyangtype_Change
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.quyangtypelist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_el_radio, {
          value: itemn.value,
          key: indexn
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(itemn.name), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue", "onChange"])])]),
    _: 1
  })]), $data.dingdaninfo.xzquyangtypeid > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_92, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      style: {
        "color": "#f8a70a",
        "text-align": "left"
      },
      innerHTML: $data.quyangtype_beizhu
    }, null, 8, _hoisted_93)]),
    _: 1
  })])) : _createCommentVNode("", true), $data.dingdaninfo.xzquyangtypeid == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_94, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[111] || (_cache[111] = [_createTextVNode(" 取样地址 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createVNode(_component_Select, {
      modelValue: $data.dingdaninfo.quyang_address_id,
      "onUpdate:modelValue": _cache[53] || (_cache[53] = $event => $data.dingdaninfo.quyang_address_id = $event),
      placeholder: "请选择取样地址",
      clearable: ""
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.quyangzhutilist, (itemn, indexn) => {
        return _openBlock(), _createBlock(_component_Option, {
          value: itemn.value
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(itemn.name), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 256))]),
      _: 1
    }, 8, ["modelValue"])]),
    _: 1
  })])) : _createCommentVNode("", true), $data.dingdaninfo.xzquyangtypeid == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_95, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[112] || (_cache[112] = [_createTextVNode(" 详细地址 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 19
  }, {
    default: _withCtx(() => [_createVNode(_component_el_input, {
      type: "text",
      modelValue: $data.dingdaninfo.quyang_address_detail,
      "onUpdate:modelValue": _cache[54] || (_cache[54] = $event => $data.dingdaninfo.quyang_address_detail = $event),
      placeholder: "详细地址"
    }, null, 8, ["modelValue"])]),
    _: 1
  })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_96, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[113] || (_cache[113] = [_createTextVNode(" 附件 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 6
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_97, [_createVNode(_component_el_tooltip, {
      content: "上传附件(最大20M)",
      placement: "left-start"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_upload, {
        class: "leftyishi",
        "http-request": $options.upload_file,
        data: {
          type: 1,
          index: 0
        },
        "before-upload": $options.handleBeforeUpload,
        "on-error": $options.handleUploadError,
        "show-file-list": false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_98, [_createVNode(_component_el_icon, {
          size: "52",
          style: {
            "color": "#3399ff"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_UploadFilled)]),
          _: 1
        })])]),
        _: 1
      }, 8, ["http-request", "before-upload", "on-error"])]),
      _: 1
    }), _cache[114] || (_cache[114] = _createElementVNode("div", null, [_createElementVNode("p", null, "支持格式"), _createElementVNode("p", null, "jpg,jpeg,png,gif,rar"), _createElementVNode("p", null, "zip,docx,doc,xls,txt,pdf")], -1))])]),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 1
  })]), _createElementVNode("div", _hoisted_99, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }), _createVNode(_component_el_col, {
    span: 6,
    class: "row-top row-top"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dingdaninfo.fujianname, (item, index) => {
      return _openBlock(), _createElementBlock("div", _hoisted_100, [_createTextVNode(_toDisplayString(item) + " ", 1), _createVNode(_component_el_tooltip, {
        content: "删除附件",
        placement: "left-start"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: "32",
          style: {
            "color": "#3399ff"
          },
          onClick: $event => $options.del_dingdaninfo_source(index)
        }, {
          default: _withCtx(() => [_createVNode(_component_Close)]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 2
      }, 1024)]);
    }), 256))]),
    _: 1
  })]), _createElementVNode("div", _hoisted_101, [_createVNode(_component_el_col, {
    span: 4,
    class: "acea-row row-center"
  }, {
    default: _withCtx(() => _cache[115] || (_cache[115] = [_createTextVNode(" 操作 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 10
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      class: "baidi_box_btn acea-row row-center",
      onClick: _cache[55] || (_cache[55] = (...args) => $options.tijiaodingdan && $options.tijiaodingdan(...args))
    }, "提交订单")]),
    _: 1
  })])])]), _createVNode(_component_zrcfooter)]);
}